import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { capitalizeEachWord } from 'app/shared/helpers/utils';
import {
  trigger,
  transition,
  style,
  animate
} from '@angular/animations';

export type AlertBoxMessageType = string | Record<string, string>;

@Component({
    selector: 'app-alert-box',
    templateUrl: './alert-box.component.html',
    styleUrls: ['./alert-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fadeSlide', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-10px)' }),
                animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
            ])
        ])
    ],
    standalone: false
})
export class AlertBoxComponent {
  @Input() type: 'info' | 'warn' | 'success' | 'error' = 'info';
  @Input() label?: string;
  @Input() message!: AlertBoxMessageType;
  @Input() ctaLabel?: string;
  @Input() dismissible = false;
  @Input() isVisible: boolean = true;

  @Output() ctaClick = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();


  onCtaClick(): void {
    this.ctaClick.emit();
  }

  onDismiss(): void {
    this.isVisible = false;
    this.dismiss.emit();
  }

  getIconName(type: string): string {
    switch (type) {
      case 'warn': return 'warning';
      case 'success': return 'check_circle';
      case 'error': return 'error';
      default: return 'info';
    }
  }

  isObjectMessage(): boolean {
    return !!this.message && typeof this.message === 'object' && !Array.isArray(this.message);
  }

  get messageEntries(): { key: string; value: string }[] {
    if (!this.isObjectMessage()) return [];
    return Object.entries(this.message as Record<string, string>).map(([key, value]) => ({
      key: capitalizeEachWord(key),
      value
    }));
  }
}
